// Onda 5b — Modal pra mostrar link publico do BM (copy-to-clipboard).
// Preserva onClick={onClose} no backdrop e o stopPropagation no card.
import { useState } from 'react';
import { createPortal } from 'react-dom';

export function ModalLinkBm({ link, onClose }: { link: { url: string; nome: string }; onClose: () => void }) {
  const [copiado, setCopiado] = useState(false);
  async function copiar() {
    try {
      await navigator.clipboard.writeText(link.url);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    } catch {
      alert('Selecione e copie o link manualmente');
    }
  }
  // FIN-UI (2026-07-14): portalizado pro body (fixed dentro das Tabs do hub caía pra baixo).
  return createPortal(
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
      onClick={onClose}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 8, padding: 28, width: '92%', maxWidth: 580 }}>
        <h3 style={{ margin: '0 0 8px', fontSize: 16, color: '#020D7F' }}>📐 BM gerado</h3>
        <div style={{ fontSize: 12, color: '#666', marginBottom: 20 }}>
          <strong>{link.nome}</strong>
        </div>
        <div style={{ background: '#FAFBFF', padding: 14, borderRadius: 6,
          border: '0.5px solid #0930D0', marginBottom: 16 }}>
          <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase',
            letterSpacing: 0.5, marginBottom: 6 }}>
            Link público pro cliente assinar
          </div>
          <div style={{ fontSize: 11, fontFamily: 'monospace', wordBreak: 'break-all',
            background: '#fff', padding: 10, borderRadius: 4, border: '0.5px solid #ddd',
            color: '#020D7F' }}>
            {link.url}
          </div>
        </div>
        <div style={{ fontSize: 12, color: '#555', marginBottom: 16, lineHeight: 1.5 }}>
          📤 <strong>Compartilhe com o cliente</strong>. Ele abre o link, confere a parcela e
          assina digitalmente. Quando assinar, a parcela vira <strong style={{color:'#7C3AED'}}>liberada</strong>
          {' '}pra emissão da NF.
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onClose}
            style={{ padding: '8px 16px', fontSize: 12, border: '0.5px solid #ddd',
              background: '#fff', color: '#555', borderRadius: 5, cursor: 'pointer' }}>Fechar</button>
          <button onClick={copiar}
            style={{ padding: '8px 22px', fontSize: 12, fontWeight: 600,
              background: copiado ? '#0a7f4a' : '#0930D0', color: '#fff',
              border: 'none', borderRadius: 5, cursor: 'pointer' }}>
            {copiado ? '✓ Link copiado' : '📋 Copiar link'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
